var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTicket = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeWidth: 1.5,
  d: "M4 3.429C4 2.639 4.716 2 5.6 2h3.2c.884 0 1.6.64 1.6 1.429s.716 1.428 1.6 1.428 1.6-.64 1.6-1.428c0-.79.716-1.429 1.6-1.429h3.2c.884 0 1.6.64 1.6 1.429V20.57c0 .79-.716 1.429-1.6 1.429h-3.2c-.884 0-1.6-.64-1.6-1.429s-.716-1.428-1.6-1.428-1.6.64-1.6 1.428c0 .79-.716 1.429-1.6 1.429H5.6c-.884 0-1.6-.64-1.6-1.429z",
  vectorEffect: "non-scaling-stroke"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeWidth: 1.5,
  d: "M9 12h6",
  vectorEffect: "non-scaling-stroke"
})));
export default SvgTicket;